import React from 'react';
import { useQueryClient } from 'react-query';
import moment from 'moment';
import { LocationIcon, YouTubeIcon, VkIcon, PhoneIcon } from '../../_assests';
import {
 Wrapper,
 Copyright,
 Privacy,
 Address,
 Contacts,
 Contact,
 Phone,
 Social,
} from './Footer.styled';
import { RootState } from '../../../store/store';
import { shallowEqual, useSelector } from 'react-redux';

interface Props {
 children?: React.ReactNode;
 className?: string;
}

export default function Footer({ children, className }: Props) {
 const date = useQueryClient().getQueryData('date');

 const configData = useSelector(
  (state: RootState) => state.config,
  shallowEqual,
 );

 return (
  <Wrapper className={className}>
   {children}

   <Copyright href={configData.siteUrl} target="_blank">
    ©{moment(date).format('YYYY')} {configData.companyLongName}
   </Copyright>

   {configData.showAgreement === '1' ? (
    <Privacy
     href={`${window.location.origin}/${configData.agreementWithoutPermissions}`}
     target="_blank"
    >
     Пользовательское соглашение
    </Privacy>
   ) : (
    ''
   )}

   {configData.showPrivacyPolicy === '1' ? (
    <Privacy
     href={`${window.location.origin}/${configData.privacyPolicy}`}
     target="_blank"
    >
     Политика конфиденциальности
    </Privacy>
   ) : (
    ''
   )}

   <Address>
    <LocationIcon />
    <span>{configData.companyAddress}</span>
   </Address>

   <Phone>
    <PhoneIcon />
    {configData.companyPhone}
   </Phone>

   <Contacts>
    {/* согласно ЗНР-С-ЛКЮЛ-00000000001444 убрал youtube. */}
    {/* <Contact>
     <a
      href="https://www.youtube.com/channel/UCPRAhaGv-4JIqj5kmymRsrw"
      target="_blank"
      rel="noreferrer"
     >
      <YouTubeIcon />
     </a>
    </Contact> */}
    <Contact>
     <a href={configData.vkUrl} target="_blank" rel="noreferrer">
      <VkIcon />
     </a>
    </Contact>
   </Contacts>
   <Social>Мы в социальных сетях</Social>
  </Wrapper>
 );
}
